<template>
  <Wrapper>
    <main class="main">
      <ol class="breadcrumb-trail__list">
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}` }"
            class="breadcrumb-trail__list--item__link"
          >
            TOP
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{
              path: `/${langPath}confirmation`,
            }"
            class="breadcrumb-trail__list--item__link"
          >
            {{ Confirmation.title[lang] }}
          </router-link>
        </li>
      </ol>
      <h1 class="page-title">
        {{ Confirmation.title[lang] }}
      </h1>
      <p class="page-description">{{ Confirmation.about[lang] }}</p>
      <section class="select-event-section" v-if="!isFromEventDetail">
        <h2 class="sub-title">{{ Confirmation.periodEvent[lang] }}</h2>
        <p class="no-events" v-if="!dataEventList.length">{{
          Confirmation.none[lang]
        }}</p>
        <ul v-else class="event__list">
          <li
            class="event__list--item"
            v-for="(event, index) in dataEventList"
            :key="index"
            @click="
              selectEvent(
                event.code,
                event.text.event_id,
                event.name,
                event.text.multi_events,
                event.text.team_event_code
              )
            "
          >
            <div class="title-area">
              <div class="event-name">
                {{ event.name }}
              </div>
              <figure class="event-logo">
                <img
                  :src="`https://tmf-virtualrun.jp/images/${event.text.event_image_file_name}`"
                  alt=""
                  width="52px"
                  height="52px"
                />
              </figure>
            </div>
            <div class="event-date">{{ event.text.event_date }}</div>
            <ul class="event-category-label__list">
              <li class="event-category-label__list--item">
                {{ event.text.event_category_label }}
              </li>
            </ul>
          </li>
        </ul>
      </section>
      <section
        id="js-multi-select-form"
        class="oauth-section flex-all-center"
        v-show="isMultiEvent"
      >
        <ul class="multi-event__list">
          <li
            class="multi-event__list--item"
            v-for="(multi, index) in multiEventList"
            :key="index"
            @click="multiSelectEvent(multi.id, multi.name)"
          >
            {{ multi.name }}
          </li>
        </ul>
      </section>
      <!-- 入力が無効の時 -->
      <Alert v-if="isNotFound" :lang="lang" :alertText="alertText"></Alert>
      <!-- キャッシュが残っていてサーバーエラーになるとき -->
      <Alert v-if="isCacheError" :lang="lang" :alertText="alertText2"></Alert>
      <section id="js-form" class="oauth-section" v-show="isSelectEvent">
        <div class="absolute-center">
          <dl class="oauth-form__dl">
            <dt class="oauth-form__dl--dt">
              {{ Confirmation.event[lang] }}
            </dt>
            <dd class="oauth-form__dl--dd">
              {{ eventName }}{{ itemEventName }}
            </dd>
          </dl>
          <dl class="oauth-form__dl">
            <dt class="oauth-form__dl--dt">
              {{ Confirmation.form.email[lang] }}
            </dt>
            <dd class="oauth-form__dl--dd">
              {{ Confirmation.form.emailPlaceHolder[lang] }}
            </dd>
            <dd class="oauth-form__dl--dd">
              <label>
                <input
                  v-model="eMail"
                  :placeholder="Confirmation.form.email[lang]"
                  :class="{ alert: isMailAlert }"
                  class="form-input"
                  type="email"
                  autocomplete="on"
                  required
                />
              </label>
            </dd>
          </dl>
          <dl class="oauth-form__dl">
            <dt class="oauth-form__dl--dt">
              {{ Confirmation.form.code[lang] }}
            </dt>
            <dd class="oauth-form__dl--dd">
              {{ Confirmation.form.codePlaceHolder[lang] }}
            </dd>
            <dd class="oauth-form__dl--dd">
              <label>
                <input
                  v-model="appAuthId"
                  :placeholder="Confirmation.form.code[lang]"
                  :class="{ alert: isAuthAlert }"
                  class="form-input"
                  type="text"
                  required
                />
              </label>
            </dd>
          </dl>
          <div class="oauth-form__button">
            <PrimaryButton type="button" @click.native="confEvent">
              {{ Confirmation.form.conf[lang] }}
            </PrimaryButton>
          </div>
        </div>
      </section>

      <!-- トークン無効 -->
      <InvalidToken
        :email="eMail"
        :appauthid="appAuthId"
        :lang="lang"
        :eventId="eventId"
        :eventName="eventName"
        v-if="isInvalidToken"
        class="child-auth-section"
      ></InvalidToken>

      <!-- 連携未完了 -->
      <NotCooperation
        :email="eMail"
        :appauthid="appAuthId"
        :lang="lang"
        :eventName="eventName"
        class="child-auth-section"
        v-if="isNotCooperation"
      ></NotCooperation>

      <!-- 連携完了 -->
      <Cooperation
        :email="eMail"
        :appauthid="appAuthId"
        :lang="lang"
        :langPath="langPath"
        :nassId="nassId"
        :eventId="eventId"
        :eventName="eventName"
        :runnerName="runnerName"
        class="child-auth-section"
        v-if="isCooperation"
      ></Cooperation>
    </main>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../components/sp/Wrapper";
import NotEnglish from "../../../components/sp/NotEnglish";
import Alert from "../../../components/sp/oauth/Alert";
import Cooperation from "../../../components/sp/oauth/Cooperation";
import NotCooperation from "../../../components/sp/oauth/NotCooperation";
import InvalidToken from "../../../components/sp/oauth/InvalidToken";
import Confirmation from "../../../assets/constants/confirmation/confirmation";
import PrimaryButton from "../../../components/sp/oauth/PrimaryButton";
import { RepositoryFactory } from "../../../api/RepositoryFactory";
export default {
  data() {
    return {
      eMail: null,
      appAuthId: null,
      isEnglishNotAvailable: false,
      isFromEventDetail: false,
      isSelectEvent: false,
      isMailAlert: false,
      isAuthAlert: false,
      isNotFound: false,
      isCacheError: false,
      isInvalidToken: false,
      isNotCooperation: false,
      isCooperation: false,
      isMultiEvent: false,
      dataEventList: [],
      dataConf: null,
      nassId: "",
      eventId: "",
      eventName: "",
      runnerName: "",
      multiEventList: [],
      itemEventName: "",
    };
  },
  // イベントリストを取得
  async created() {
    const EventRepository = RepositoryFactory.get("event");
    // イベント詳細からの遷移時はイベントを取得
    if (this.$route.query.event) {
      this.isFromEventDetail = true;
      const nassId = this.$route.query.event;
      const params = {
        code: nassId,
        lang: this.lang,
      };
      const response = await EventRepository.getEvent(params);
      this.nassId = nassId;
      this.eventName = response.data.name;
      // 複数イベントでイベント詳細から遷移時
      if (this.$route.query.multi_event) {
        this.eventId = this.$route.query.multi_event;
        sessionStorage.setItem("eventId", this.$route.query.multi_event);
      } else {
        this.eventId = response.data.text.event_id;
        sessionStorage.setItem("eventId", this.eventId);
      }
      this.isSelectEvent = true;
      await this.initialFlag();
      await this.formScroll("js-form");
      return;
    }

    // 通常遷移 イベント一覧を取得
    const params = {
      lang: this.lang,
      oauthPeriod: true,
    };
    const response = await EventRepository.getEventList(params);
    this.dataEventList = response.data.items;
  },
  methods: {
    selectEvent: async function (
      nassId,
      eventId,
      eventName,
      multiEventList,
      teamEventCode
    ) {
      if (teamEventCode) {
        // チーム対抗イベントのアプリ連携ページへ遷移
        location.href = `/${this.langPath}company/confirmation?event=${teamEventCode}`;
        return;
      }
      sessionStorage.setItem("eventId", eventId);
      this.nassId = nassId;
      this.eventId = eventId;
      this.eventName = eventName;
      this.itemEventName = "";
      // 複数イベントの場合
      if (eventId.includes(",")) {
        this.multiEventList = multiEventList;
        this.isMultiEvent = true;
        this.isSelectEvent = false;
        await this.initialFlag();
        await this.formScroll("js-multi-select-form");
        return;
      }
      this.isMultiEvent = false;
      this.isSelectEvent = true;
      await this.initialFlag();
      await this.formScroll("js-form");
    },
    // MEMO 必ず前にselectEventが叩かれている前提
    multiSelectEvent: async function (eventId, eventName) {
      sessionStorage.setItem("eventId", eventId);
      this.eventId = eventId;
      this.itemEventName = eventName;
      this.isSelectEvent = true;
      await this.initialFlag();
      await this.formScroll("js-form");
    },
    initialFlag: function () {
      // 初期化
      this.eMail = "";
      this.appAuthId = "";
      this.isNotFound = false;
      this.isCacheError = false;
      this.isInvalidToken = false;
      this.isCooperation = false;
      this.isNotCooperation = false;
    },
    formScroll: function (elementId) {
      const element = document.getElementById(elementId);
      element.scrollIntoView({ behavior: "smooth" });
    },
    confEvent: async function () {
      // 初期化
      this.isNotFound = false;
      this.isCacheError = false;
      this.isInvalidToken = false;
      this.isCooperation = false;
      this.isNotCooperation = false;
      // 入力判定
      if (!this.eMail && !this.appAuthId) {
        this.isMailAlert = true;
        this.isAuthAlert = true;
        return;
      }
      if (!this.eMail) {
        this.isMailAlert = true;
        return;
      }
      if (!this.appAuthId) {
        this.isAuthAlert = true;
        return;
      }
      // 認証の際、外部サイトに遷移するため一時的に保存する
      sessionStorage.setItem("email", this.eMail);
      sessionStorage.setItem("app_auth_code", this.appAuthId);
      // 認証状態確認
      const data = {
        event_id: this.eventId,
        email: this.eMail,
        app_auth_code: this.appAuthId,
      };
      try {
        const OauthUserRepository = RepositoryFactory.get("oauth");
        const response = await OauthUserRepository.postConf(data);
        this.dataConf = response.data;
        this.runnerName = response.data.runnerName;
      } catch (e) {
        // email or id が見つからなかった場合
        if (e.response.status === 404) {
          this.isNotFound = true;
          return;
        } else {
          this.isCacheError = true;
          return;
        }
      }
      // アクセストークンが無効
      if (!this.dataConf.isRunkeeperToken) {
        this.isInvalidToken = true;
        return;
      }
      // 未連携
      if (!this.dataConf.isRegisterApplication) {
        this.isNotCooperation = true;
        return;
      }
      // 連携済み
      if (this.dataConf.isRegisterApplication) {
        this.isCooperation = true;
      }
    },
  },
  computed: {
    Confirmation: function () {
      return Confirmation;
    },
    alertText: function () {
      return "not-found";
    },
    alertText2: function () {
      return "cache-error";
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  watch: {
    eMail: function () {
      this.isMailAlert = false;
      this.isNotFound = false;
      this.isCacheError = false;
    },
    appAuthId: function () {
      this.isAuthAlert = false;
      this.isNotFound = false;
      this.isCacheError = false;
    },
  },
  components: {
    Wrapper,
    NotEnglish,
    Alert,
    Cooperation,
    NotCooperation,
    InvalidToken,
    PrimaryButton,
  },
  name: "Confirmation",
};
</script>

<style scoped>
.main {
  .page-title {
    margin: 40px 0 0 0;
    line-height: 1.25;
    padding: 0 0 0 15px;
    border-left: solid 8px var(--defaultBlackColor);
    font-size: 32px;
    font-weight: 900;
  }

  .page-description {
    margin: 40px 0 0 0;
    line-height: 1.5;
    white-space: pre-line;
  }

  .select-event-section {
    margin: 40px 0 0 0;

    .sub-title {
      line-height: 1.33;
      font-size: 24px;
    }

    .no-events {
      margin: 40px 0 0 0;
      line-height: 1.5;
    }

    .event__list {
      &--item {
        padding: 20px 0;
        border-bottom: solid 1px var(--defaultBlackColor);
        background-color: var(--defaultWhiteColor);

        &:hover {
          background-color: var(--defaultGrayColor);
          transition-duration: 0.3s;
        }

        .title-area {
          display: flex;
          align-items: center;

          .event-name {
            flex: 1;
            margin: 0 10px 0 0;
            font-size: 20px;
            line-height: 1.33;
          }

          .event-logo {
            padding: 5px;
            border: solid 1px var(--defaultGrayColor);
          }
        }

        .event-date {
          padding: 18px 0 0 0;
          font-size: 16px;
          font-weight: bold;
          line-height: 1.6;
          position: relative;

          &::before {
            content: "";
            width: 60px;
            height: 6px;
            position: absolute;
            top: 6px;
            background-color: var(--defaultBlackColor);
          }
        }
      }
    }
  }

  .oauth-section {
    min-height: 100vh;
    position: relative;

    .multi-event__list {
      width: 100%;
      &--item {
        padding: 40px 0;
        border-bottom: solid 1px var(--defaultBlackColor);
        background-color: var(--defaultWhiteColor);

        &:hover {
          background-color: var(--defaultGrayColor);
          transition-duration: 0.3s;
        }
      }
    }

    .absolute-center {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .oauth-form__dl {
        &:not(:first-of-type) {
          margin: 20px 0 0 0;
        }

        &--dt {
          margin: 25px 0 0 0;
          font-size: 16px;
          font-weight: bold;
          color: var(--defaultBlackColor);
        }

        &--dd {
          margin: 10px 0 0 0;
          font-size: 14px;

          .form-input {
            width: 100%;
            height: 50px;
            padding: 0 0 0 10px;
            border: solid 1px var(--grayColor3);
            font-size: 16px;
          }

          .alert {
            background-color: var(--alertColor2);
            border: 1px solid var(--alertColor);
          }
        }
      }

      .oauth-form__button {
        margin: 30px 0 0 0;
      }
    }
  }
  .child-auth-section {
    /*スクロールの余白を考慮する*/
    padding: 60px 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sp/confirmation/Confirmation.vue